<!--
INTELLECTUAL PROPERTY NOTICE
© Kaleida Ltd and/or Orbit Tickets Ltd. All rights reserved.
This file contains a combination of:
- Protected Intellectual Property owned by Kaleida Ltd; and
- Custom / Included Intellectual Property owned by the Customer,
and forms part of an application developed by Kaleida within the Platform.
Protected Intellectual Property may only be used as incorporated within applications developed by Kaleida within the Platform and must not be used, reproduced, adapted, or incorporated into any application developed by or on behalf of the Customer (being any application not developed by Kaleida), whether or not such application forms part of the Platform.
Custom / Included Intellectual Property may be used, reproduced, adapted, and incorporated into any application, system, or product developed by or on behalf of the Customer, whether or not such application forms part of the Platform, subject always to the terms of the agreement and provided that such use does not include or rely upon any Protected Intellectual Property of Kaleida Ltd.
For the avoidance of doubt, where separation between Protected Intellectual Property and Custom / Included Intellectual Property is unclear, this file shall be treated as containing Protected Intellectual Property.
-->
<!-- IP-NOTICE: MIXED -->
<mat-toolbar color="primary" class="orbit-app-header mat-elevation-z4">
	<div class="header-row flex-layout-row flex-layout-align-space-between-center">
		<div class="header-leading flex-layout-row flex-layout-align-left-center">
			<button
				type="button"
				mat-icon-button
				class="header-menu-button"
				(click)="toggleMenu()"
				*ngIf="this.usersService.userPermissions.action.menu.available"
				aria-label="Toggle side menu"
				title="Toggle Side Menu"
			>
				<orbit-icon name="menu"></orbit-icon>
			</button>
			<a class="header-logo-link" [routerLink]="['']"><img class="header-logo" src="/assets/images/inverselogo.svg" alt="Orbit" /></a>
		</div>

		<div class="header-actions flex-layout-row flex-layout-align-left-center">
			<button
				*ngIf="showKioskLink"
				type="button"
				mat-stroked-button
				class="anchor-button load-kiosk-button orbit-button orbit-button--secondary orbit-button--small orbit-button--icon-leading"
				(click)="loadKiosk()"
			>
				<span class="load-kiosk-button-content">
					<orbit-icon aria-hidden="true" name="open_in_new"></orbit-icon>
					<span class="load-kiosk-button-label">Load Kiosk</span>
				</span>
			</button>
			<button
				type="button"
				class="account-menu-button"
				[matMenuTriggerFor]="appMenu"
				aria-label="Open user menu"
				title="Load User Menu"
			>
				<span class="account-initials" aria-hidden="true">{{ loggedInInitials }}</span>
				<span class="username">{{ loggedInFullName }}</span>
				<orbit-icon class="account-chevron" aria-hidden="true" name="expand_more"></orbit-icon>
			</button>
			<mat-menu #appMenu="matMenu" class="orbit-account-menu" xPosition="before">
				<div class="orbit-account-menu-header" (click)="$event.stopPropagation()">
					<div class="orbit-account-menu-name">{{ loggedInFullName }}</div>
					<div class="orbit-account-menu-username">{{ loggedInUserName }}</div>
				</div>
				<button mat-menu-item *ngIf="showResetPassword" (click)="resetPassword()">
					<orbit-icon name="lock_reset"></orbit-icon>
					<span>Reset Password</span>
				</button>
				<button mat-menu-item (click)="logout()">
					<orbit-icon name="logout"></orbit-icon>
					<span>Sign out</span>
				</button>
			</mat-menu>
		</div>
	</div>
</mat-toolbar>
